import { Routes } from '@angular/router';
import { AuthGuard } from '../../core/_guards/auth.guards';
import { AdminApplicationsComponent } from './componets/pages/admin-applications/admin-applications.component';
import { AdminTokensComponent } from './componets/pages/admin-tokens/admin-tokens.component';
import { AdminstratorComponent } from './adminstrator.component';

export const adminstratorRoutes: Routes = [
  {
    path: 'administrator',
    component: AdminstratorComponent,
    canActivate: [AuthGuard],
    data: {
      role: 'Admin',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'applications',
      },
      {
        path: 'applications',
        component: AdminApplicationsComponent,
      },
      {
        path: 'tokens',
        component: AdminTokensComponent,
      },
    ],
  },
];
